<template>
    <div class="workorderInfromation">
        <div class="workorderInfromation_title">
            <!--<div v-if="timeLineData.czCzdwmc" class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">-->
                <!--{{timeLineData.czCzdwmc}}-->
            <!--</div>-->
            <div class="workorderInfromation_t_zhzx ZX">
                指挥中心
            </div>
            <div v-if="timeLineData.czCzrmc" class="workorderInfromation_t_describe">
                <!--<span class="icon-leader"><span class="path1"></span><span class="path2"></span></span>-->
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_describe">
                重新发起
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-progress workorderInfromation_icon"></span>
            <div>
                {{timeLineData.czCzjgwb}}
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, ref, getCurrentInstance, onMounted, inject} from 'vue'

    export default {
        name: "timeLine_PSTS",
        props:["timeLineList"],
        setup(props, context) {
            // let gdId = inject("gdId");
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czCzrmc": "张倩",  //处置人名称
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "theDay": "1", //第n天"
            // });
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
